<template>
  <form @submit="onSubmit">
    <v-card>
      <v-card-title class="headline">
        New list
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Title*"
                v-model="title"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                :items="languages"
                item-text="title"
                item-value="code"
                label="Term language*"
                v-model="termLanguage"
                required
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                :items="languages"
                item-text="title"
                item-value="code"
                label="Meaning language*"
                v-model="meaningLanguage"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                label="Description"
                v-model="description"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                label="Visible to"
                :items="visibilityOptions"
                v-model="visibility"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">Close</v-btn>
        <v-btn type="submit" color="blue darken-1" text>Create</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AddStudyList",
  props: ["onFinish"],
  data: () => ({
    title: "",
    termLanguage: "",
    meaningLanguage: "",
    visibility: "public",
    description: "",
    languages: [
      { code: "de", title: "Deutsch" },
      { code: "en", title: "English" },
      { code: "es", title: "Español" },
      { code: "fr", title: "Français" },
      { code: "it", title: "Italiano" },
      { code: "zh-CN", title: "中文" },
      { code: "ru", title: "Русский" },
      { code: "jp", title: "日本語" }
    ],
    visibilityOptions: [
      { value: "public", text: "Everyone" },
      { value: "private", text: "Just me" }
    ],
  }),
  methods: {
    ...mapActions(["addStudyList"]),
    onSubmit(e) {
      e.preventDefault();

      const payload = {
        title: this.title,
        termLanguage: this.termLanguage,
        meaningLanguage: this.meaningLanguage,
        description: this.description,
        private: this.visibility === "private",
      };

      this.$store.dispatch("addStudyList", payload).then(newStudyList => {
        this.$router.push({
          name: "StudyListDetail",
          params: { id: newStudyList.id }
        });
        this.onFinish();
      });
    },
    onClose() {
      this.onFinish();
    }
  }
};
</script>
